import React from "react";
import type { ReactZoomPanPinchContentRef } from "react-zoom-pan-pinch";

export interface VisualizerCanvasZoomPanelProps {
  utils: ReactZoomPanPinchContentRef;
}

const btnClass =
  "grid h-[34px] w-[34px] u-p-0 my-1 place-items-center rounded-full border-none bg-white text-black text-[22px] leading-none cursor-pointer shadow-[0_1px_4px_rgba(0,0,0,0.25)]";

export function ZoomPanel({ utils }: VisualizerCanvasZoomPanelProps) {
  return (
    <div
      className="dock-zoom-panel absolute right-3 top-1/2 z-50 flex -translate-y-1/2 flex-col items-center pointer-events-auto"
    >
      <button type="button" aria-label="Zoom in" className={btnClass} onClick={() => utils.zoomIn()}>
        +
      </button>
      <button type="button" aria-label="Zoom out" className={btnClass} onClick={() => utils.zoomOut()}>
        −
      </button>
    </div>
  );
}

export default ZoomPanel;
